import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNaviconSearchActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			opacity: .5,
			cx: 14.4167,
			cy: 14.418,
			r: 7.60123,
			transform: "rotate(-45 14.4167 14.418)",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14.4167,
			cy: 14.418,
			r: 7.10123,
			transform: "rotate(-45 14.4167 14.418)",
			stroke: "#C948D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.791 19.793L21.1347 21.1367",
			stroke: "#C948D8"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22.0312,
			y: 20.2422,
			width: 8.23466,
			height: 2.53374,
			rx: .633435,
			transform: "rotate(45 22.0312 20.2422)",
			stroke: "#C948D8"
		})
	]
});
export default SvgNaviconSearchActive;
